import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { BaseComponent } from './component/base/base.component';
import { CentsToMajorUnitPipe } from './pipes/cents-to-major-unit.pipe';
import { DatexPipe } from './pipes/datex.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { FormatSecondsPipe } from './pipes/format-seconds.pipe';
import { GetProductPropertyValueByCodePipe } from './pipes/get-product-property-value-by-code.pipe';
import { MoneyFormatPipe } from './pipes/money-format.pipe';
import { ProductHasPropertyPipe } from './pipes/product-has-property.pipe';
import { ProductsHasPropertyPipe } from './pipes/products-has-property.pipe';
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { ThousandsFormatPipe } from './pipes/thousands-format.pipe';
import { TimeBetweenDatesPipe } from './pipes/time-between-dates.pipe';
import { TimeFromIntPipe } from './pipes/time-from-int.pipe';
import { TimeFromStringPipe } from './pipes/time-from-string.pipe';
import { FormatTimeZonePipe } from './pipes/format-timezone.pipe';
import { TranslateObjectFieldPipe } from './pipes/translate-object-field.pipe';
import { NotificationService } from './services/notification.service';
import { CoreFacade } from './+state';
import { DistancePipe } from './pipes/distance.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { MomentDatePipe } from './pipes/moment-date.pipe';
import { DateTimePipe, DateTimeRangePipe } from './pipes/intl-date-format.pipe';
import { RelativeTimePipe } from './pipes/intl-relative-time.pipe';
import { ImgFallbackDirective } from './directives/img-fallback.directive';
import { AutofillDirective } from './directives/autofill.directive';
import { TrapFocusDirective } from './directives/trap-focus.directive';
import { ParentAriaLabelDirective } from './directives/parent-aria-label.directive';
import { AriaListDirective } from './directives/aria-list.directive';
import { TransformOverrideDirective } from './directives/transform-observer.directive';
import { HideFromScreenreaderDirective } from './directives/hide-from-screenreader.directive';
import { AriaVisibilityObserverDirective } from './directives/aria-visibility-observer.directive';
import { UpdateNativeAriaDirective } from './directives/update-ion-element.directive';
import { FindDayNamePipe } from './pipes/find-dayname.pipe';
import { RidangoDateTimePipe } from '../lib/pipes/ridango-date-time.pipe';

@NgModule({
    imports: [HttpClientModule],
    declarations: [
        ThousandsFormatPipe,
        TranslateObjectFieldPipe,
        TimeBetweenDatesPipe,
        ProductHasPropertyPipe,
        ProductsHasPropertyPipe,
        GetProductPropertyValueByCodePipe,
        MoneyFormatPipe,
        CentsToMajorUnitPipe,
        SafeResourceUrlPipe,
        SortPipe,
        FormatSecondsPipe,
        TimeFromIntPipe,
        DatexPipe,
        TimeFromStringPipe,
        DurationPipe,
        BaseComponent,
        FormatTimeZonePipe,
        RidangoDateTimePipe,
        DistancePipe,
        TruncatePipe,
        MomentDatePipe,
        DateTimePipe,
        DateTimeRangePipe,
        RelativeTimePipe,
        ImgFallbackDirective,
        TrapFocusDirective,
        HideFromScreenreaderDirective,
        UpdateNativeAriaDirective,
        AriaListDirective,
        ParentAriaLabelDirective,
        AriaVisibilityObserverDirective,
        AutofillDirective,
        TransformOverrideDirective,
        FindDayNamePipe
    ],
    exports: [
        ThousandsFormatPipe,
        TranslateObjectFieldPipe,
        TimeBetweenDatesPipe,
        ProductHasPropertyPipe,
        ProductsHasPropertyPipe,
        GetProductPropertyValueByCodePipe,
        MoneyFormatPipe,
        CentsToMajorUnitPipe,
        SafeResourceUrlPipe,
        SortPipe,
        FormatSecondsPipe,
        TimeFromIntPipe,
        DatexPipe,
        TimeFromStringPipe,
        DurationPipe,
        BaseComponent,
        FormatTimeZonePipe,
        RidangoDateTimePipe,
        DistancePipe,
        TruncatePipe,
        DateTimePipe,
        DateTimeRangePipe,
        RelativeTimePipe,
        MomentDatePipe,
        ImgFallbackDirective,
        TrapFocusDirective,
        HideFromScreenreaderDirective,
        UpdateNativeAriaDirective,
        AriaVisibilityObserverDirective,
        AriaListDirective,
        ParentAriaLabelDirective,
        AutofillDirective,
        TransformOverrideDirective,
        FindDayNamePipe
    ],
    providers: [
        TranslateObjectFieldPipe,
        TimeFromStringPipe,
        TimeBetweenDatesPipe,
        NotificationService,
        DurationPipe,
        CoreFacade
    ]
})
export class CoreModule {}

// https://medium.com/@tomsu/how-to-build-a-library-for-angular-apps-4f9b38b0ed11
// https://github.com/angular/angular/issues/15548#issuecomment-387009186
